import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AtInternetService } from 'src/app/services/at-internet.service';
import { HelpComponent } from './help/help.component';

@Component({
  selector: 'app-bloc-help',
  templateUrl: './bloc-help.component.html',
  styleUrls: ['./bloc-help.component.scss']
})
export class BlocHelpComponent {
  @Input() tag;

  constructor(private helpDialogRef: MatDialog,
    private atInternetService: AtInternetService) {
  }

  redirect(url) {
    this.atInternetService.generateClickAction(this.tag, 'aide_en_ligne', 'besoin_daide');
    window.open(url, "_blank");
    // Keep for evol later
    // this.helpDialogRef.open(HelpComponent, {
    //   panelClass: 'footer-dialog',
    //   data: {
    //     "title": "footer.CGU.title",
    //     "tag": this.tag
    //   }
    // });
  }

}
